function forceShowCartRemoveButtons() {
  document.querySelectorAll('cart-remove-button').forEach(function (el) {
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('pointer-events', 'auto', 'important');

    var link = el.querySelector('a');
    if (link) {
      link.style.setProperty('opacity', '1', 'important');
      link.style.setProperty('visibility', 'visible', 'important');
    }
  });
}

document.addEventListener('DOMContentLoaded', forceShowCartRemoveButtons);
window.addEventListener('load', forceShowCartRemoveButtons);

const cartObserver = new MutationObserver(forceShowCartRemoveButtons);
cartObserver.observe(document.body, { childList: true, subtree: true });